import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { store } from "./helpers/store";
import { PrivateRoute } from "./components/PrivateRoute/PrivateRoute";
// core components
import Admin from "layouts/Admin.js";
import LoginPage from "views/LoginPage/LoginPage";

import "assets/css/material-dashboard-react.css?v=1.8.0";

const rootElement = document.getElementById("root");
const hist = createBrowserHistory();

createRoot(rootElement).render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        <Route path="/login" component={LoginPage} />
        <PrivateRoute path="/admin" component={Admin} />
        <Redirect from="/" to="/admin/dashboard" />
      </Switch>
    </Router>
  </Provider>
);
